import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

const Common_Fixed_Popup = ({
  show,
  onStopBreak,
  popup_body
}) => {
  
  return (
    <>

      <Modal
        show={show}
        onHide={onStopBreak}
        animation={false}
        backdrop="static"
        centered
        size="md"
        className={"blur-background"}
      >
        {/* <Modal.Header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Modal.Title
            style={{ color: "#055837", cursor: "default" }}
            className="modal-title"
          >
           {popup_title} 
          </Modal.Title>
        </Modal.Header> */}

        <Modal.Body>
            {popup_body}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Common_Fixed_Popup;
